import { Command } from 'cmdk';
import { Lock } from 'lucide-react';
import type { Project, Task } from '@timato/shared';
import { ProjectDot } from '@/components/ProjectDot';
import { cn } from '@/lib/cn';
import { formatDurationCompact } from '@/lib/time';
import { useLockHolder } from './useLockHolder';

export const taskOptionClass = 'flex items-center gap-[10px] px-3 py-[9px] text-[13px] font-semibold text-ink cursor-pointer select-none data-[selected=true]:bg-inset';

type Props = { task: Task; project: Project | undefined; onSelect: () => void; /** A lock held by someone else refuses the pick (online), as starting the timer on it would. */ locked?: boolean };

/** One task in a goal list: its project's dot, the name, the project and the logged time against any estimate. */
export function TaskOption({ task: t, project: p, onSelect, locked = false }: Props) {
  const holder = useLockHolder()(t);
  return (
    <Command.Item value={t.id} onSelect={onSelect} className={cn(taskOptionClass, holder && 'opacity-60')} aria-disabled={locked && !!holder && navigator.onLine}>
      <ProjectDot project={p} />
      <span className={cn('truncate', holder && 'line-through')}>{t.name}</span>
      {holder && <span className="inline-flex items-center gap-1 text-inline-meta text-ink-2 shrink-0"><Lock size={11} /> {holder}</span>}
      <span className="ml-auto flex items-center gap-[10px] shrink-0">
        <span className="text-[11px] font-semibold text-ink-2 truncate max-w-[90px]">{p?.name}</span>
        <span className="font-mono text-[11px] text-ink-2 bg-inset rounded-[4px] px-[6px] py-[2px]">{t.estimateSec ? `${formatDurationCompact(t.trackedSec)} / ${formatDurationCompact(t.estimateSec)}` : formatDurationCompact(t.trackedSec)}</span>
      </span>
    </Command.Item>
  );
}
